import { createContext, useContext } from "react";

export const ThreadListLoadFailedContext = createContext(false);

export function useThreadListLoadFailed(): boolean {
    return useContext(ThreadListLoadFailedContext);
}

interface TrackListLoadDeps<TResult> {
    baseList: () => Promise<TResult>;
    setListFailed: (failed: boolean) => void;
}

/** Record whether the latest list load failed, rethrowing its error so the runtime can load the list again. */
export function trackListLoad<TResult>({
    baseList,
    setListFailed,
}: TrackListLoadDeps<TResult>): () => Promise<TResult> {
    return async () => {
        try {
            const result = await baseList();
            setListFailed(false);
            return result;
        } catch (error) {
            setListFailed(true);
            throw error;
        }
    };
}
